import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";

export const configJSON = require("./config");

export interface ISlotMasterDetail {
  id: string;
  type: string;
  attributes: {
    id: number;
    threshold: number;
    activated: boolean;
    slot_type: string;
    start_time: string | null;
    end_time: string | null;
    interval_minutes: number | null;
    slots_per_day: number;
    per_slot_capacity: number;
    created_at: string;
    updated_at: string;
    mobile_service: {
      id: number;
      name: string;
      name_ar: string;
    };
    regions: Array<{ id: number; name: string }>;
    areas: Array<{ id: number; name: string }>;
    stores: Array<{ id: number; name: string }>;
    slots: Array<{
      id: number;
      day: string | null;
      start_time: string;
      end_time: string;
      activated: boolean;
    }>;
    slot_overrides: Array<{
      id: number;
      start_date: string;
      end_date: string;
      start_time: string | null;
      end_time: string | null;
      reason: string;
      activated: boolean;
    }>;
  };
}

const emptyData: ISlotMasterDetail = {
  id: "",
  type: "",
  attributes: {
    id: 0,
    threshold: 0,
    activated: false,
    slot_type: "pickup",
    start_time: null,
    end_time: null,
    interval_minutes: null,
    slots_per_day: 0,
    per_slot_capacity: 0,
    created_at: "",
    updated_at: "",
    mobile_service: { id: 0, name: "", name_ar: "" },
    regions: [],
    areas: [],
    stores: [],
    slots: [],
    slot_overrides: [],
  },
};
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  isLoading: boolean;
  noData: boolean;
  data: ISlotMasterDetail;
  // Customizable Area End
}

export interface SS {}

class SlotManagementViewController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  slotViewMessageId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse && requestId === this.slotViewMessageId) {
      this.setState({ isLoading: false });
      if (successResponse.data) {
        const item = Array.isArray(successResponse.data)
          ? successResponse.data[0]
          : successResponse.data;
        if (item) {
          this.setState({ data: item, noData: false });
        } else {
          this.setState({ noData: true });
        }
      } else {
        this.setState({ noData: true });
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getSlotDetail();
  }

  getSlotDetail = () => {
    const id = this.props.navigation.getParam("id");
    this.setState({ isLoading: true });

    const requestMessage = MakeApiMessage({
      url: `${configJSON.ApiUrls.slotManagementList}/${id}`,
      method: "GET",
    });

    this.slotViewMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  goBack = () => {
    this.props.navigation.navigate("SlotManagementList");
  };
  // Customizable Area End
}

export default SlotManagementViewController;
export { emptyData };
